import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type OpcaoRegraDeCalculo = Readonly<{
  id: string
  name: string
  code?: string | null
  calculoPassivo?: boolean | null
}>

export type FiltrosCatalogoRegraDeCalculo = Readonly<{
  [Campo in keyof OpcaoRegraDeCalculo]?: OpcaoRegraDeCalculo[Campo] | undefined
}>

export type SelecaoCatalogoRegraDeCalculo =
  | OpcaoRegraDeCalculo
  | readonly OpcaoRegraDeCalculo[]
  | null

export type OperacoesCatalogoRegraDeCalculo = Readonly<{
  listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoRegraDeCalculo[]>
}>

export const DESCRITOR_CATALOGO_REGRA_DE_CALCULO: CatalogoDescriptor<OpcaoRegraDeCalculo> = Object.freeze({
  nome: 'regras-de-calculo',
  versaoProjecao: 2,
  validarItens: (valor: unknown): valor is readonly OpcaoRegraDeCalculo[] => (
    Array.isArray(valor) && valor.every((item: unknown) => typeof item === 'object'
      && item !== null && !Array.isArray(item)
      && Object.keys(item).every(campo => ['id', 'name', 'code', 'calculoPassivo'].includes(campo)))
  ),
})
